import React from 'react';

export default class Home extends React.Component{

  render() {
    return <div></div>
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js